import type { FaireProductEntity } from "../../entity_types/product";

export const p_9nre38ns26: FaireProductEntity = {
  token: "p_9nre38ns26",
  type: "product",
  name: "Peach Juice/ 100% JUICE/ 10.8 fl oz pack of 12",
  brandToken: "b_7h76tk1dcp",
  brandName: "ALO drink",
  imageUrl:
    "https://cdn.faire.com/fastly/66ef5af116e2327280f71183b88789b3a58c055c9bd096da7cfa2d1557400251.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/95b24867d4f54eca6e4c17707c7e79f0763e94c9270807c1612caca8a84b30ad.jpeg",
    "https://cdn.faire.com/fastly/aef153238244b963dbd868d3874c438ef18a321d17b755b658a3b683c09d1330.jpeg",
    "https://cdn.faire.com/fastly/7f0a12a509e313803f8eb72bf2d9c4e442338da030d7b59c6de39427acf71dff.jpeg",
  ],
  priceDollars: 1.87,
  description:
    "PEACH with Real Peach Pulp\n\nJUICY PERFECTION, STRAIGHT FROM THE ORCHARD\nExperience the luscious essence of summer with our 100% Peach Juice. Made from sun-ripened peaches, each sip is bursting with sweet, tangy flavor, straight from nature's bounty.\n\nHere’s Even More Goodness:\n\n * Not from concentrate \n * With real peach pulp \n * No Added Sugar \n * NON GMO\n * Gluten Free\n * All Natural\n * 100% Vegan\n * No Preservatives\n * Electrolyte Rich\n * Superior Hydration\n * ",
  tags: [],
  msrpDollars: 3.74,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:07.784Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
